export const blockToDisplayName = {
    field: "Field",
    plantationfield: "Plantation Field",
    alchemist: "Alchemist Tower",
    kitchen: "Cookery",
    graveyard: "Graveyard",
    netherworker: "Nether Mine",
    archery: "Archery",
    baker: "Bakery",
    barracks: "Barracks",
    barrackstower: "Barracks Tower",
    beekeeper: "Apiary",
    blacksmith: "Blacksmith's Hut",
    builder: "Builder's Hut",
    chickenherder: "Chicken Farmer's Hut",
    citizen: "Residence",
    combatacademy: "Combat Academy",
    composter: "Composter's Hut",
    concretemixer: "Concrete Mixer's Hut",
    cook: "Restaurant",
    cowboy: "Cowhand's Hut",
    crusher: "Crusher",
    deliveryman: "Courier's Hut",
    dyer: "Dyer's Hut",
    enchanter: "Enchanter's Tower",
    farmer: "Farm",
    fisherman: "Fisher's Hut",
    fletcher: "Fletcher's Hut",
    florist: "Flower Shop",
    glassblower: "Glassblower's Hut",
    guardtower: "Guard Tower",
    hospital: "Hospital",
    library: "Library",
    lumberjack: "Forester's Hut",
    mechanic: "Mechanic's Hut",
    miner: "Mine",
    plantation: "Plantation",
    rabbithutch: "Rabbit Hutch",
    sawmill: "Sawmill",
    school: "School",
    shepherd: "Shepherd's Hut",
    sifter: "Sifter",
    smeltery: "Smeltery",
    stonemason: "Stonemason's Hut",
    stonesmeltery: "Stone Smeltery",
    swineherder: "Swineherd's Hut",
    tavern: "Tavern",
    townhall: "Town Hall",
    university: "University",
    warehouse: "Warehouse",
    mysticalsite: "Mystical Site",
} satisfies Record<string, string>;

export type HutBlock = keyof typeof blockToDisplayName;
